// 运营分析API接口
import request from './request';

// 人员负载与个人分析（按人维度）
export const agentStatsApi = {
  // 人员负载看板
  getWorkload: (params) => request.get('/agent-stats/workload', { params }),

  // 某代投员的客户明细
  getWorkloadOrders: (agentId, params) => request.get(`/agent-stats/workload/${agentId}/orders`, { params }),

  // 个人画像
  getPersonal: (params) => request.get('/agent-stats/personal', { params }),

  // 全员排行榜
  getRanking: (params) => request.get('/agent-stats/ranking', { params }),

  // 当前用户每日实际投递（日历用）
  getDailyActual: (params) => request.get('/agent-stats/daily-actual', { params }),

  // 首页今日待办 + 优先处理 TOP5
  getTodaySummary: () => request.get('/agent-stats/today-summary'),

  // 业绩目标卡（员工查自己，管理员可带 agent_id）
  getTargetCard: (params) => request.get('/agent-stats/target-card', { params }),

  // 目标调整记录
  getTargetLogs: (params) => request.get('/agent-stats/target-logs', { params }),

  // 员工对比与目标（管理员）
  getTargetCompare: (params) => request.get('/agent-stats/target-compare', { params }),

  // 设定/调整目标（管理员）
  updateTarget: (data) => request.put('/agent-stats/targets', data),

  // 团队排期资源周视图（管理员）
  getTeamWeek: (params) => request.get('/agent-stats/team-week', { params }),

  // 某日明细：当日计划 + 实际投递
  getDailyDetail: (params) => request.get('/agent-stats/daily-detail', { params })
};

export const analysisApi = {
  // 核心指标
  getCoreMetrics: (params) => request.get('/analysis/metrics', { params }),
  
  // 订单趋势
  getOrderTrend: (params) => request.get('/analysis/order-trend', { params }),
  
  // 来源分布
  getSourceDistribution: (params) => request.get('/analysis/source-distribution', { params }),
  
  // 代投员绩效排行
  getAgentRanking: (params) => request.get('/analysis/agent-ranking', { params }),
  
  // 团队排行（组长团队 + 管理员团队）
  getTeamRanking: (params) => request.get('/analysis/team-ranking', { params }),
  
  // 角色每日投递统计（admin / superadmin / leader / delivery）
  getRoleDailyStats: (params) => request.get('/analysis/role-daily-stats', { params }),
  
  // 完成率趋势（已废弃，兼容旧调用）
  getCompletionRateTrend: (params) => request.get('/analysis/completion-trend', { params }),
  
  // 数据明细
  getDetailData: (params) => request.get('/analysis/details', { params }),

  // 团队订单统计（按人员管理关系统计组长下代投员的订单数据及星级分布）
  getTeamOrderStats: (params) => request.get('/analysis/team-order-stats', { params })
};
